<template>
  <div id="myDateShow">
    <div class="title">查看 营销商户资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">商户类型</div>
        <div class="value">{{marketingMerchants.marketingMerchantsType}}</div>
      </div>
      <div class="line">
        <div class="key">商户名称</div>
        <div class="value">{{marketingMerchants.marketingMerchantsName}}</div>
      </div>
      <div class="line">
        <div class="key">商户联系人</div>
        <div class="value">{{marketingMerchants.marketingMerchantsOwner}}</div>
      </div>
      <div class="line">
        <div class="key">商户地址</div>
        <div class="value">{{marketingMerchants.marketingMerchantsAddress}}</div>
      </div>
      <div class="line">
        <div class="key">商户简介</div>
        <div class="value">
          {{marketingMerchants.marketingMerchantsIntro}}
        </div>
      </div>
      <div class="line">
        <div class="key">入驻时间</div>
        <div class="value">{{marketingMerchants.marketingMerchantsTime}}</div>
      </div>
      <div class="line">
        <div class="key">营业执照</div>
        <div class="value">
          <img :src=marketingMerchants.marketingMerchantsLicense />
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getMarketingMerchantsById,newVue} from "../../network/marketingMerchants";

  export default {
    name: "marketingMerchantsData",
    components: {},
    data(){
      return{
        marketingMerchantsId:"",
        marketingMerchants:{}
      }
    },
    methods:{
      backClick(){
        this.$router.push("../list");
      },
    },
    created() {
      newVue.obj = this;

      this.common.HeaderLocationTwo.href =  "/marketingMerchants/list";
      this.common.HeaderLocationTwo.name = "营销商户列表管理"
      this.common.HeaderLocationThree.name = "营销商户详情"
      this.marketingMerchantsId = this.$route.params.id;

      getMarketingMerchantsById(this.marketingMerchantsId).then(res => {
        this.marketingMerchants = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
